import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=c570a39c&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c570a39c')) {
      api.createRecord('c570a39c', component.options)
    } else {
      api.reload('c570a39c', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=c570a39c&", function () {
      api.rerender('c570a39c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22iLSi91dX5R6/JS/comp/FavElement.vue"
export default component.exports